import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as organization from '../../organization'

export const RESOURCE = {
  payload: {
    description:
      'A sub-unit within a organization that groups related departments, functions, or administrative areas.',
    dimension: organization.RESOURCE.payload,
    level: 1,
    name: 'Division',
    partialId: PartialId.Standard.create('div'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
